import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-bespoke-riser-form',
    templateUrl: './bespoke-riser-form.component.html',
    styleUrls: ['./bespoke-riser-form.component.scss']
})
export class BespokeRiserFormComponent implements OnInit {
    @Input() product;
    @Output() recalculate = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    calcBespokeCost() {
        this.recalculate.emit();
    }

    toggleRiserRequired() {
        if (this.product.riserRequired) {
            this.product.riser = {
                quantity: 0,
                height: 100,
                thickness: 30,
                weightPerSellUnit: 0,
                pricePerSellUnit: 0,
                weight: 0,
                price: 0,
            };
        } else {
            this.product.riser = undefined;
        }
        this.calcBespokeCost();
    }

}
